import { render, staticRenderFns } from "./FeaturesMenu.vue?vue&type=template&id=32ed08a9&scoped=true"
import script from "./FeaturesMenu.vue?vue&type=script&lang=js"
export * from "./FeaturesMenu.vue?vue&type=script&lang=js"
import style0 from "./FeaturesMenu.vue?vue&type=style&index=0&id=32ed08a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ed08a9",
  null
  
)

export default component.exports